import axios, { AxiosRequestConfig } from 'axios';

import { ISfccProductSearchApiSettings, ISfccSearchResult, SFCCHeader } from './sfccApiTypes';

export const fetchSfccSearchResults = async (
  searchApiSettings: ISfccProductSearchApiSettings,
  query: string
): Promise<ISfccSearchResult | null> => {
  if (!searchApiSettings.clientId) {
    console.warn('SFCC Client ID is not set');
  }

  const url = `${searchApiSettings.baseUrl}/product_search?${query}`;
  const requestConfig: AxiosRequestConfig = {
    headers: {
      [SFCCHeader.ClientId]: searchApiSettings.clientId,
    },
    withCredentials: true,
  };

  try {
    const { data } = await axios.get<ISfccSearchResult>(url, requestConfig);
    return data;
  } catch (error) {
    console.error(`fetchSfccSearchResults request for ${query} failed:`, error);
    return null;
  }
};
